module.exports = __webpack_public_path__ + "static/media/note3.b61ad5da.svg";